import React from 'react';
import Slider from '@material-ui/core/Slider';
import jalaliMoment from 'jalali-moment';
import { connect } from 'react-redux';
import * as registerAttendanceAction from './../../actions/registerAttendace';
import { toast } from 'react-toastify';

class SwipeButton extends React.Component{
    constructor(props){
        super(props);
        this.state={
            value:50,
        }
    }
    handleSwipe = (event,value) =>{
            this.setState({value:this.parseSliderValue(value)})
    }
    parseSliderValue = (number) => {
        const MIN =  10;
        const MAX =  90;
        return Math.min(Math.max(number, MIN), MAX)
    }
    handleOnCommit = async (event,value)=>{
        try{
            const date =new jalaliMoment();
        debugger;
            
            if(this.props.registerAttendace.isUserInWorkPlace){
                if(value > 80){
                    try{
                        debugger;
                        this.props.loading(true);
                        this.props.startAddAddendaceLog({
                            LogDateTime:date.format("YYYY-MM-DDTHH:mm:ss.SSS Z"),
                            AttendanceType:{
                                Value:"1001"
                            },
                            Recorder:{
                                Id : this.props.registerAttendace.userWorkplace.Recorders[0].Id,
                            },
                            RegisterationDate : date.format("YYYY-MM-DDTHH:mm:ss.SSS Z")
    
                        })
                        this.props.loading(false);

                    }catch(error){
                        this.props.loading(false);
                        toast.error(error.response.data.Message, {
                            position: toast.POSITION.BOTTOM_CENTER
                          });
                    }
                    
                }else if(value<20){
                    try{
                        this.props.loading(true);
                        this.props.startAddAddendaceLog({
                            LogDateTime:date.format("YYYY-MM-DDTHH:mm:ss.SSS Z"),
                            AttendanceType:{
                                Value:"1002"
                            },
                            Recorder:{
                                Id : this.props.registerAttendace.userWorkplace.Recorders[0].Id,
                            },
                            RegisterationDate : date.format("YYYY-MM-DDTHH:mm:ss.SSS Z")
                        })
                        this.props.loading(false);
                    }catch(error){
                        this.props.loading(false);
                        toast.error(error.response.data.Message, {
                            position: toast.POSITION.BOTTOM_CENTER
                          });
                    }
                    
                }
            }
            else{
                if(localStorage.getItem('userLocale') ==='fa-IR'){
                    toast.error("شما در محل کار حضور ندارید", {
                        position: toast.POSITION.BOTTOM_CENTER
                      });
                    }
                    else{
                        toast.error("You are not in the workplace", {
                            position: toast.POSITION.BOTTOM_CENTER
                          });
                        }
            }
        }
        catch(error){
            toast.error(error.response.data.Message, {
                position: toast.POSITION.BOTTOM_CENTER
              });
        }
        this.setState({value : 50})

    }

    render = () => {
      
        const swipButtonPosition = this.props.registerAttendace.attendaceLogs.length > 0 ? 24 : 7;
        const style = {bottom:swipButtonPosition+"%"}
        return(
            <div id="button-background"  style={style} >
                <span className="slide-text enter">ورود</span>
                <span className="slide-text exit">خروج</span>
                <Slider  onMouseDown={this.handleClick} 
                // disabled={!this.props.registerAttendace.isUserInWorkPlace} track={false}
                 value={this.state.value} aria-label="ios slider" onChangeCommitted={this.handleOnCommit} onClick={this.handleClick} onChange={this.handleSwipe} />
            </div>
        );

    }
}
const mapToStateProps = (state) =>{
    return state;
}
export default connect(mapToStateProps,registerAttendanceAction)(SwipeButton)